import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withModifiers as _withModifiers, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5bc7e4fd")

_pushScopeId("data-v-5bc7e4fd")
const _hoisted_1 = { class: "r-grid container" }
const _hoisted_2 = { class: "con" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode("UIN "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "con employee-name"
}
const _hoisted_5 = {
  key: 1,
  class: "r-grid con container user__tab-container"
}
const _hoisted_6 = { class: "button-group user__tab-group" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", null, "Details", -1)
const _hoisted_9 = { class: "details-container" }
const _hoisted_10 = /*#__PURE__*/_createVNode("dt", null, "UIN:", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("dt", null, "Title:", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("dt", null, "Org Code:", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("dt", null, "Org Description:", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("dt", null, "Dept/Unit:", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("dt", null, "College:", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("dt", null, "E-mail:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Status "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "field-description" }, "The users' access capability; An inactive employee is precluded from using the GoTime system.", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("option", { value: "active" }, "Active", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("option", { value: "inactive" }, "Inactive", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Holiday Group "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", { value: "groupA" }, "Group A", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("option", { value: "groupB" }, "Group B", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode("FTE "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_25 = {
  key: 0,
  class: "field-description"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("label", null, [
  /*#__PURE__*/_createTextVNode("Primary Supervisor UIN "),
  /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*")
], -1)
const _hoisted_27 = {
  key: 1,
  id: "primary-supervisor",
  class: "form-error"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("label", null, "Alt Supervisor UIN", -1)
const _hoisted_29 = {
  key: 2,
  id: "secondary-supervisor",
  class: "form-error"
}
const _hoisted_30 = {
  key: 4,
  class: "button-group"
}
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/_createVNode("h3", null, "Schedule", -1)
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createVNode("b", null, "WARNING!", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" Updating a previous schedule will impact leave records. If an employee has a new schedule, select \"Add Schedule\" from the dropdown instead of updating a previous schedule. ")
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, null, -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("option", { value: "new" }, "Add New Schedule", -1)
const _hoisted_40 = { key: 2 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Schedule Start Date ")
const _hoisted_42 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*", -1)
const _hoisted_43 = { class: "button-group" }
const _hoisted_44 = {
  key: 4,
  class: "week-list"
}
const _hoisted_45 = { class: "day" }
const _hoisted_46 = /*#__PURE__*/_createVNode("span", { class: "asterisk" }, "*", -1)
const _hoisted_47 = {
  key: 7,
  class: "button-group"
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 2,
  class: "schedule-display line"
}
const _hoisted_51 = {
  key: 3,
  class: "schedule-display line"
}
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "line" }, "Conflicts:", -1)
const _hoisted_53 = /*#__PURE__*/_createStaticVNode("<span class=\"line red\" data-v-5bc7e4fd>Important!</span><span data-v-5bc7e4fd><b data-v-5bc7e4fd>WARNING!</b> Your action will have destructive consequences to this employee’s existing leaves. Ensure you truly intent to update the schedule instead of adding a new schedule. For a job change scenario, the new schedule should be added instead of updating a previous schedule.<br data-v-5bc7e4fd> The leave items listed will be moved into a conflict state.<br data-v-5bc7e4fd> The <span class=\"reset red\" data-v-5bc7e4fd>*</span>conflict status on the leave items will be irreversible.<br data-v-5bc7e4fd> You will also be unable to change the schedule again until all conflicts have been resolved for this employee.<br data-v-5bc7e4fd> If you continue with this action, to resolve the conflict in the current benefit year you must delete the request and resubmit it.<br data-v-5bc7e4fd><br data-v-5bc7e4fd><b data-v-5bc7e4fd><span class=\"reset red\" data-v-5bc7e4fd>*</span>Conflict</b> - A leave that was submitted under the previous schedule which no longer aligns with the newly updated hours </span>", 2)
const _hoisted_55 = {
  key: 5,
  class: "line-b"
}
const _hoisted_56 = { class: "button-group" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createVNode("span", { class: "extra-space" }, "Please ensure all information is correctly entered.", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("h3", null, "Details", -1)
const _hoisted_61 = {
  key: 2,
  class: "details-container"
}
const _hoisted_62 = /*#__PURE__*/_createTextVNode("UIN: ")
const _hoisted_63 = /*#__PURE__*/_createTextVNode("Employee Name: ")
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Title: ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Org Code: ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Org Description: ")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Dept/Unit: ")
const _hoisted_68 = /*#__PURE__*/_createTextVNode("College: ")
const _hoisted_69 = /*#__PURE__*/_createTextVNode("E-mail: ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode("Status: ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Holiday Group: ")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("FTE: ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("Supervisor UIN: ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode("Supervisor Name: ")
const _hoisted_75 = /*#__PURE__*/_createTextVNode("Alternative Supervisor UIN: ")
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Alternative Supervisor Name: ")
const _hoisted_77 = /*#__PURE__*/_createVNode("h3", null, "Shared Calendar Assignment List", -1)
const _hoisted_78 = { class: "details-container" }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = /*#__PURE__*/_createVNode("h3", null, "Schedule", -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Schedule Start Date: ")
const _hoisted_82 = { class: "button-group" }
const _hoisted_83 = {
  key: 4,
  class: "user-leaves con"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("h3", null, "Leaves", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_List = _resolveComponent("List")!
  const _component_tempate = _resolveComponent("tempate")!
  const _component_NewRequestButton = _resolveComponent("NewRequestButton")!
  const _component_ManageSingleEmployee = _resolveComponent("ManageSingleEmployee")!
  const _component_NewRequest = _resolveComponent("NewRequest")!
  const _component_LeaveItem = _resolveComponent("LeaveItem")!
  const _component_LeaveBalance = _resolveComponent("LeaveBalance")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("h2", null, _toDisplayString(_ctx.title), 1)
    ]),
    _withDirectives(_createVNode("div", _hoisted_2, [
      _createVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.lookUpUser(_ctx.uin)), ["prevent"]))
      }, [
        _hoisted_3,
        _withDirectives(_createVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.uin = $event)),
          type: "number",
          max: "999999999",
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.uin]
        ]),
        _createVNode(_component_Button, {
          text: "Look-up User",
          type: "submit"
        })
      ], 32)
    ], 512), [
      [_vShow, _ctx.tab === 'search']
    ]),
    (_ctx.userLookUpData && _ctx.tab !== 'search')
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("h2", null, _toDisplayString(_ctx.userLookUpData.name), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.tab !== 'search' && _ctx.edit)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode("ol", _hoisted_6, [
            _createVNode("li", {
              class: ["item-button", { 'selected': _ctx.tab === 'details'
      || _ctx.tab === 'user-update-summary'
      || _ctx.tab === 'user-submit-summary' }],
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.tab = 'details'))
            }, "Details", 2),
            _createVNode("li", {
              class: ["item-button", { 'selected': _ctx.tab === 'schedule'
      || _ctx.tab === 'schedule-update-summary'
      || _ctx.tab === 'schedule-submit-summary' }],
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.tab = 'schedule'))
            }, "Schedule", 2),
            _createVNode("li", {
              class: ["item-button", { 'selected': _ctx.tab === 'leaves'
      || _ctx.tab === 'schedule-update-summary'
      || _ctx.tab === 'schedule-submit-summary'
      || _ctx.tab === 'leave-item'
      || _ctx.tab === 'new-request'
      || _ctx.tab === 'leave-balance' }],
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.tab = 'leaves'))
            }, "Leaves", 2)
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("form", {
      class: "con",
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.submitType)), ["prevent"]))
    }, [
      (_ctx.userLookUpData)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("div", null, [
                _hoisted_10,
                _createVNode("dd", null, _toDisplayString(_ctx.uin), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_11,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.title), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_12,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.orgCode), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_13,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.orgDescription), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_14,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.unit), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_15,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.college), 1)
              ]),
              _createVNode("div", null, [
                _hoisted_16,
                _createVNode("dd", null, _toDisplayString(_ctx.userLookUpData.email), 1)
              ])
            ]),
            _hoisted_17,
            _hoisted_18,
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formDetails.employeeStatus = $event)),
              required: ""
            }, [
              _hoisted_19,
              _hoisted_20
            ], 512), [
              [_vModelSelect, _ctx.formDetails.employeeStatus]
            ]),
            _hoisted_21,
            _withDirectives(_createVNode("select", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formDetails.holidayGroup = $event)),
              required: ""
            }, [
              _hoisted_22,
              _hoisted_23
            ], 512), [
              [_vModelSelect, _ctx.formDetails.holidayGroup]
            ]),
            (!_ctx.userWithDays)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _hoisted_24,
                  (_ctx.edit === true)
                    ? (_openBlock(), _createBlock("span", _hoisted_25, " Important: Must create a new schedule if FTE changes. "))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formDetails.fte = $event)),
                      class: "fte-field",
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.fteChange())),
                      type: "number",
                      max: "1",
                      min: "0",
                      step: "0.001",
                      required: ""
                    }, null, 544), [
                      [_vModelText, _ctx.formDetails.fte]
                    ]),
                    _createVNode("span", null, " = " + _toDisplayString(_ctx.calculatePercentage(_ctx.formDetails.fte)) + "%", 1)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _hoisted_26,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formDetails.primarySupervisor = $event)),
              class: {'input-error': _ctx.formDetailsErrors.primarySupervisor},
              "aria-invalid": _ctx.formDetailsErrors.primarySupervisor,
              "aria-describedby": "primary-supervisor",
              type: "number",
              max: "999999999",
              min: "0",
              step: "1",
              required: ""
            }, null, 10, ["aria-invalid"]), [
              [_vModelText, _ctx.formDetails.primarySupervisor]
            ]),
            (_ctx.formDetailsErrors.primarySupervisor)
              ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.formDetailsErrors.primarySupervisor), 1))
              : _createCommentVNode("", true),
            _hoisted_28,
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formDetails.secondarySupervisor = $event)),
              class: {'input-error': _ctx.formDetailsErrors.secondarySupervisor},
              "aria-invalid": _ctx.formDetailsErrors.primarySupervisor,
              "aria-describedby": "secondary-supervisor",
              type: "number",
              max: "999999999",
              min: "0",
              step: "1"
            }, null, 10, ["aria-invalid"]), [
              [_vModelText, _ctx.formDetails.secondarySupervisor]
            ]),
            (_ctx.formDetailsErrors.secondarySupervisor)
              ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.formDetailsErrors.secondarySupervisor), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_List, {
              list: _ctx.formDetails.calendarsList,
              header: "Shared Calendar Assignment List",
              required: false,
              description: "\n        Please work with your IT department for the alias name of the GoTime Shared\n        Calendar(s). Add one calendar at a time, multiple calendars can be assigned.",
              maxListLength: 10,
              onListChanged: _ctx.calendarsListChanged,
              listType: "string",
              listTypeName: "Calendar",
              ref: "calendarsList",
              calendarUIN: _ctx.uin,
              disabled: _ctx.userInfoData.isHRAdminReadOnly
            }, null, 8, ["list", "onListChanged", "calendarUIN", "disabled"]),
            (_ctx.edit)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 3,
                  text: "Continue to Update User Summary",
                  type: "submit",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.submitType = 'update-user-check')),
                  disabled: _ctx.cantEditOwn || _ctx.userInfoData.isHRAdminReadOnly
                }, null, 8, ["disabled"]))
              : (!_ctx.edit)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _createVNode(_component_Button, {
                      text: "Back to Search",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.tab = 'search'))
                    }),
                    _createVNode(_component_Button, {
                      text: "Continue to Schedule",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submitType = 'schedule'))
                    })
                  ]))
                : _createCommentVNode("", true)
          ], 512)), [
            [_vShow, _ctx.tab === 'details']
          ])
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.tab !== 'schedule-update-summary'
  && _ctx.tab !== 'schedule-submit-summary'
  && _ctx.tab === 'details']
    ]),
    _withDirectives(_createVNode("form", {
      class: "con",
      onSubmit: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.submitType)), ["prevent"]))
    }, [
      (_ctx.userLookUpData)
        ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_31, [
            _hoisted_32,
            (_ctx.edit && !_ctx.userWithDays)
              ? (_openBlock(), _createBlock("p", _hoisted_33, [
                  _hoisted_34,
                  _hoisted_35
                ]))
              : _createCommentVNode("", true),
            (_ctx.edit && _ctx.userWithDays)
              ? (_openBlock(), _createBlock("span", _hoisted_36, " The schedule page is not applicable for this user type. "))
              : _createCommentVNode("", true),
            (_ctx.edit && !_ctx.userWithDays)
              ? (_openBlock(), _createBlock("label", _hoisted_37, "Selected Schedule:"))
              : _createCommentVNode("", true),
            (_ctx.edit && !_ctx.userWithDays)
              ? _withDirectives((_openBlock(), _createBlock("select", {
                  key: 3,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formSchedule.selectedSchedule = $event)),
                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.changeSchedule(_ctx.formSchedule.selectedSchedule)))
                }, [
                  _hoisted_38,
                  _hoisted_39,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.userScheduleData, (week, index) => {
                    return (_openBlock(), _createBlock("option", {
                      key: index,
                      value: week.uuid
                    }, _toDisplayString(`${week.start_date||''} ${week.start_date?'-':''} ${(week.end_date||'Latest')}`), 9, ["value"]))
                  }), 128))
                ], 544)), [
                  [_vModelSelect, _ctx.formSchedule.selectedSchedule]
                ])
              : _createCommentVNode("", true),
            (_ctx.formSchedule.selectedSchedule)
              ? (_openBlock(), _createBlock(_component_tempate, { key: 4 }, {
                  default: _withId(() => [
                    (!_ctx.newSchedule && _ctx.edit && !_ctx.userWithDays)
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: "item-button",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.unlockSchedule())),
                          ref: "unlockSchedule"
                        }, " Unlock Schedule To Edit ", 512))
                      : _createCommentVNode("", true),
                    (!_ctx.newSchedule && _ctx.edit && !_ctx.userWithDays)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          text: _ctx.disableSchedule ? 'Unlock Schedule To Edit' : 'Lock Schedule',
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.unlockSchedule())),
                          disabled: _ctx.userInfoData.isHRAdminReadOnly
                        }, null, 8, ["text", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.newSchedule)
                      ? (_openBlock(), _createBlock("label", _hoisted_40, [
                          _hoisted_41,
                          _hoisted_42
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.newSchedule)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 3,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.formSchedule.scheduleStartDate = $event)),
                          type: "date",
                          class: "date",
                          placeholder: "Date",
                          disabled: _ctx.disableSchedule,
                          required: ""
                        }, null, 8, ["disabled"])), [
                          [_vModelText, _ctx.formSchedule.scheduleStartDate]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_43, [
                      (_ctx.newSchedule && !_ctx.userWithDays)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            text: "Use Default Schedule",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.calcSchedule(_ctx.userLookUpData.workweek, _ctx.formDetails.fte))),
                            disabled: ( _ctx.formDetails.fte < 1 ) || _ctx.disableSchedule || _ctx.userInfoData.isHRAdminReadOnly
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                      (_ctx.newSchedule && !_ctx.userWithDays)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            type: "submit",
                            text: "Reset Schedule",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.resetScheduleAlert())),
                            disabled: _ctx.disableSchedule || _ctx.userInfoData.isHRAdminReadOnly
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
                    ]),
                    (!_ctx.userWithDays)
                      ? (_openBlock(), _createBlock("div", _hoisted_44, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formSchedule.week, (day, index) => {
                            return (_openBlock(), _createBlock(_Fragment, { key: index }, [
                              _createVNode("label", _hoisted_45, [
                                _createTextVNode(_toDisplayString(day.day) + " (Hours): ", 1),
                                _hoisted_46
                              ]),
                              _withDirectives(_createVNode("input", {
                                "onUpdate:modelValue": ($event: any) => (day.hours = $event),
                                type: "number",
                                max: "24",
                                min: "0",
                                step: "0.01",
                                disabled: _ctx.disableSchedule,
                                required: ""
                              }, null, 8, ["onUpdate:modelValue", "disabled"]), [
                                [_vModelText, day.hours]
                              ])
                            ], 64))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.edit && _ctx.newSchedule !== true && !_ctx.userWithDays)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 5,
                          type: "submit",
                          text: "Continue to Update Schedule Summary",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.submitType = 'update-schedule-check')),
                          disabled: _ctx.disableSchedule
                        }, null, 8, ["disabled"]))
                      : (_ctx.edit && _ctx.newSchedule === true && !_ctx.userWithDays)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 6,
                            type: "submit",
                            text: "Add Schedule",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.submitType = 'submit-schedule-check')),
                            disabled: _ctx.disableSchedule || _ctx.cantEditOwn || _ctx.userInfoData.isHRAdminReadOnly
                          }, null, 8, ["disabled"]))
                        : (!_ctx.edit)
                          ? (_openBlock(), _createBlock("div", _hoisted_47, [
                              _createVNode(_component_Button, {
                                text: "Back to Edit Details",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.tab = 'details'))
                              }),
                              _createVNode(_component_Button, {
                                text: "Add User",
                                type: "submit",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.submitType = 'submit-user-check'))
                              })
                            ]))
                          : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 512)), [
            [_vShow, _ctx.tab === 'schedule']
          ])
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.tab !== 'schedule-update-summary'
  && _ctx.tab !== 'schedule-submit-summary'
  && _ctx.tab === 'schedule']
    ]),
    (_ctx.tab === 'schedule-update-summary' || _ctx.tab === 'schedule-submit-summary')
      ? (_openBlock(), _createBlock("form", {
          key: 2,
          onSubmit: _cache[31] || (_cache[31] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.submitType)), ["prevent"])),
          class: "con summary"
        }, [
          (_ctx.tab === 'schedule-update-summary')
            ? (_openBlock(), _createBlock("h3", _hoisted_48, "Schedule Update Summary"))
            : (_ctx.tab === 'schedule-submit-summary')
              ? (_openBlock(), _createBlock("h3", _hoisted_49, "Schedule Submit Summary"))
              : _createCommentVNode("", true),
          (_ctx.tab === 'schedule-update-summary')
            ? (_openBlock(), _createBlock("div", _hoisted_50, [
                _createVNode("span", null, "Schedule Range: " + _toDisplayString(_ctx.scheduleRangeDisplay), 1)
              ]))
            : (_ctx.tab === 'schedule-submit-summary')
              ? (_openBlock(), _createBlock("div", _hoisted_51, [
                  _createVNode("span", null, "Schedule Start Date: " + _toDisplayString(_ctx.formSchedule.scheduleStartDate), 1)
                ]))
              : _createCommentVNode("", true),
          _hoisted_52,
          (_ctx.checkScheduleData && _ctx.checkScheduleData.length > 0)
            ? (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checkScheduleData, (conflict, index) => {
                  return (_openBlock(), _createBlock("span", {
                    class: "red",
                    key: index
                  }, _toDisplayString(conflict.date) + " - " + _toDisplayString(conflict.duration_hours) + " Hours ", 1))
                }), 128)),
                _hoisted_53
              ], 64))
            : (_ctx.checkScheduleData && _ctx.checkScheduleData.length === 0)
              ? (_openBlock(), _createBlock("span", _hoisted_55, " There are no leave conflicts. "))
              : _createCommentVNode("", true),
          _createVNode("div", _hoisted_56, [
            _createVNode(_component_Button, {
              text: "Back to Edit Schedule",
              onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.submitType = 'schedule'))
            }),
            (_ctx.tab === 'schedule-update-summary')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  text: "Confirm & Update Schedule",
                  onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.submitType = 'update-schedule'))
                }))
              : (_ctx.tab === 'schedule-submit-summary')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    text: "Confirm & Add Schedule",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.submitType = 'submit-schedule'))
                  }))
                : _createCommentVNode("", true)
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.tab === 'user-update-summary' || _ctx.tab === 'user-submit-summary')
      ? (_openBlock(), _createBlock("form", {
          key: 3,
          onSubmit: _cache[36] || (_cache[36] = _withModifiers(($event: any) => (_ctx.submitForm(_ctx.submitType)), ["prevent"])),
          class: "con summary"
        }, [
          (_ctx.tab === 'user-update-summary')
            ? (_openBlock(), _createBlock("h3", _hoisted_57, "User Update Summary"))
            : (_ctx.tab === 'user-submit-summary')
              ? (_openBlock(), _createBlock("h3", _hoisted_58, "User Submit Summary"))
              : _createCommentVNode("", true),
          _hoisted_59,
          _hoisted_60,
          (_ctx.checkUserData)
            ? (_openBlock(), _createBlock("div", _hoisted_61, [
                _createVNode("span", null, [
                  _hoisted_62,
                  _createVNode("strong", null, _toDisplayString(_ctx.uin), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_63,
                  _createVNode("strong", null, _toDisplayString(_ctx.checkUserData.employeeName), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_64,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.title), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_65,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.orgCode), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_66,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.orgDescription), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_67,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.unit), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_68,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.college), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_69,
                  _createVNode("strong", null, _toDisplayString(_ctx.userLookUpData.email), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_70,
                  _createVNode("strong", null, _toDisplayString(_ctx.formDetails.employeeStatus), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_71,
                  _createVNode("strong", null, _toDisplayString(_ctx.formDetails.holidayGroup), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_72,
                  _createVNode("strong", null, _toDisplayString(_ctx.formDetails.fte), 1)
                ]),
                _createVNode("span", null, [
                  _hoisted_73,
                  _createVNode("strong", {
                    class: { 'red': _ctx.supervisorError }
                  }, _toDisplayString(_ctx.parseSupervisorSummary.uin), 3)
                ]),
                _createVNode("span", null, [
                  _hoisted_74,
                  _createVNode("strong", {
                    class: { 'red': _ctx.supervisorError }
                  }, _toDisplayString(_ctx.parseSupervisorSummary.name), 3)
                ]),
                _createVNode("span", null, [
                  _hoisted_75,
                  _createVNode("strong", {
                    class: { 'red': _ctx.altSupervisorError }
                  }, _toDisplayString(_ctx.parseSupervisorSummary.altUin), 3)
                ]),
                _createVNode("span", null, [
                  _hoisted_76,
                  _createVNode("strong", {
                    class: { 'red': _ctx.altSupervisorError }
                  }, _toDisplayString(_ctx.parseSupervisorSummary.altName), 3)
                ])
              ]))
            : _createCommentVNode("", true),
          _hoisted_77,
          _createVNode("div", _hoisted_78, [
            (_ctx.formDetails.calendarsList.length > 0)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.formDetails.calendarsList, (item, index) => {
                  return (_openBlock(), _createBlock("span", { key: index }, _toDisplayString(item), 1))
                }), 128))
              : (_openBlock(), _createBlock("span", _hoisted_79, "This user is not assigned to any calendars."))
          ]),
          (_ctx.edit === false && _ctx.tab === 'user-submit-summary' && !_ctx.userWithDays)
            ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
                _hoisted_80,
                _createVNode("span", null, [
                  _hoisted_81,
                  _createVNode("strong", null, _toDisplayString(_ctx.formSchedule.scheduleStartDate), 1)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formSchedule.week, (day, index) => {
                  return (_openBlock(), _createBlock("span", { key: index }, [
                    _createTextVNode(_toDisplayString(day.day) + ": ", 1),
                    _createVNode("strong", null, _toDisplayString(day.hours), 1)
                  ]))
                }), 128))
              ], 64))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_82, [
            (_ctx.tab === 'user-update-summary')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  text: "Back to Edit User",
                  onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.submitType = 'details'))
                }))
              : (_ctx.tab === 'user-submit-summary')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    text: "Back to Edit Schedule",
                    onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submitType = 'schedule'))
                  }))
                : _createCommentVNode("", true),
            (_ctx.tab === 'user-update-summary')
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 2,
                  text: "Confirm & Update User",
                  onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submitType = 'update-user')),
                  disabled: _ctx.supervisorError || _ctx.altSupervisorError
                }, null, 8, ["disabled"]))
              : (_ctx.tab === 'user-submit-summary')
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 3,
                    text: "Confirm & Add User",
                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.submitType = 'submit-user')),
                    disabled: _ctx.supervisorError || _ctx.altSupervisorError
                  }, null, 8, ["disabled"]))
                : _createCommentVNode("", true)
          ])
        ], 32))
      : _createCommentVNode("", true),
    (_ctx.tab === 'leaves'
  || _ctx.tab === 'new-request'
  || _ctx.tab === 'leave-item'
  || _ctx.tab === 'leave-balance')
      ? (_openBlock(), _createBlock("div", _hoisted_83, [
          _hoisted_84,
          (_ctx.tab === 'leaves')
            ? (_openBlock(), _createBlock(_component_ManageSingleEmployee, {
                userInfoData: _ctx.userLookUpData,
                isHRAdminReadOnly: _ctx.userInfoData.isHRAdminReadOnly,
                key: _ctx.tab === 'leaves'
              }, {
                default: _withId(() => [
                  (_ctx.$route.name === 'View/Edit User')
                    ? (_openBlock(), _createBlock(_component_NewRequestButton, {
                        key: 0,
                        link: "",
                        onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.tab = 'new-request'))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["userInfoData", "isHRAdminReadOnly"]))
            : _createCommentVNode("", true),
          (_ctx.tab === 'new-request')
            ? (_openBlock(), _createBlock(_component_NewRequest, {
                key: 1,
                uin: _ctx.uin,
                isHRAdminReadOnly: _ctx.userInfoData.isHRAdminReadOnly
              }, null, 8, ["uin", "isHRAdminReadOnly"]))
            : _createCommentVNode("", true),
          (_ctx.tab === 'leave-item' && _ctx.$route.params.uuid)
            ? (_openBlock(), _createBlock(_component_LeaveItem, {
                userInfoData: _ctx.userLookUpData,
                key: _ctx.$route.params.uuid,
                isHRAdminReadOnly: _ctx.userInfoData.isHRAdminReadOnly
              }, null, 8, ["userInfoData", "isHRAdminReadOnly"]))
            : _createCommentVNode("", true),
          (_ctx.tab === 'leave-balance')
            ? (_openBlock(), _createBlock(_component_LeaveBalance, {
                key: 3,
                userInfoData: _ctx.userLookUpData
              }, null, 8, ["userInfoData"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
})